export default "__VITE_PUBLIC_ASSET__15c87360__"